<template>
<section class="padding">
    <div class="flex">
  <h3>Our online sessions</h3>
  <h4>We offer transformative online and offline yoga classes for kids, aged <br> three to fifteen. We focus on the mind-body connect and making </h4>
<div class="buttons">
<button>Live Classes</button>
<button class="button1">Pre-recorded</button>
</div>
</div>
</section>
</template>


<script>
export default {

}
</script>

<style scoped>
.padding{
    padding-top: 182px;
}
.button1{
     color: #44526B;
  background-color: #FFFFF2;
  border: 2px solid #FF8100
}
.flex{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;
    margin: auto;
    text-align: center;
    justify-content: space-around;
    height: 219px;
}
.buttons{
        display: flex;
    justify-content: space-around;
   width: 398px;
    flex-wrap: wrap;
}
h4{
    color: #44526B;
    font-weight: 500;
    line-height: 150%;
    margin-bottom: 17px;
}
h3{
    color: #44526B;
}
button{
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 45px;
    border-radius: 50px;
    cursor: pointer;
    transition: 0.3s ease-in;
        margin-bottom: 17px;
}
@media(max-width : 1080px){
    .buttons{
max-width: 341px;
    }
}
</style>